import { useState } from 'react'

// Tracks which tab the reader came from so a panel can slide along tab order.
// active and previousIndex live in one state object so the pair cannot skew.
export function useTabDirection<T extends string>(
  order: readonly T[],
  initial: T
) {
  const [state, setState] = useState({
    active: initial,
    previousIndex: order.indexOf(initial),
  })

  function select(next: T) {
    if (next === state.active) return

    setState((current) => ({
      active: next,
      previousIndex: order.indexOf(current.active),
    }))
  }

  return {
    active: state.active,
    index: order.indexOf(state.active),
    previousIndex: state.previousIndex,
    select,
  }
}
